//Global Imports
import React from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import moment from "moment";
//End Global Imports

//Local Imports
import Footer from "../../../components/layout/Footer";
import { RightArrowFilledIcon } from "../../../assets/Icons";
import StepOne from "./StepOne";
import { SuccessfullBanner } from "./SuccessfullBanner";
import OtpPhase from "../OtpPhase";
import { getRequestTime, registerUserData, sendOtp, validateOtp } from "../../../services/auth";
import TermsModal from "./StepOne/TermsModal";
import MasterVendorOtpBoxModal from "./StepOne/MasterVendorOtpBoxModal";
import { Mixpanel } from "../../../constants/mixpanel";
import { toast, ToastContainer } from "react-toastify";
//End Local Imports

const SignUp: React.FC = () => {
  const navigate = useNavigate();
  const [otpValue, saveOtpValue] = React.useState<string>("");
  const [otpError, setOTPError] = React.useState<boolean>(false);
  const [isActiveStep, setActiveStep] = React.useState<number>(1);
  const [countryCode, saveCountryCode] = React.useState<string>("+91");
  const [isOTPVerified, setOTPVerified] = React.useState<boolean>(false);
  const [isRegisteredSuccessful, setIsRegisteredSuccessful] = React.useState<boolean>(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = React.useState<boolean>(false);
  const [masterVendorEmail, setMasterVendorEmail] = React.useState<string | undefined>(undefined);
  const [isMasterVendorOtpBox, setIsMasterVendorOtpBox] = React.useState<boolean>(false);
  const [userData, saveUserData] = React.useState({
    mobileNumber: "",
    email: "",
    password: "",
    confirmpassword: "",
    vendorCode: "",
  });
  const [verifyOtpError, setVerifyOtpError] = React.useState<string>("");
  const [date, saveDate] = React.useState(Date.now() + 120000);
  const [dateKey, saveDateKey] = React.useState(0);
  const [otpLoader, setOtpLoader] = React.useState(false);

  //TODO@Chintan: Need to modified Sign-Up flow as per old flow email and mobile both have to be verified


  const verifyOTP = () => {
    setOtpLoader(true);
    getRequestTime().then((response: any) => {
      const reqTime = response.data.currentTime;

      validateOtp({
        email_phone: countryCode + userData.mobileNumber,
        otp: otpValue,
        otpType: "mobile",
      })
        .then((response: any) => {
          const responseTime = response?.data?.timeStamp;
          const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
            moment(reqTime, "hh:mm:ss"),
            "seconds",
          );
          if (response?.data?.success && timeStampDiff <= 10) {
            getRequestTime().then((response: any) => {
              const reqTime = response.data.currentTime;

              setOTPError(false);
              setOTPVerified(true);
              registerUserData({
                email: userData.email,
                password: userData.password,
                is_email_verified: true,
                is_phone_verified: true,
                is_master_verified: masterVendorEmail ? true : false,
                phoneNumber: countryCode + userData.mobileNumber,
                partnerType: "moneyhop",
                vendor_code: userData.vendorCode,
              })
                .then((res: any) => {
                  Mixpanel.track("Verify_signup");
                  const responseTime = res?.data?.timeStamp;
                  const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
                    moment(reqTime, "hh:mm:ss"),
                    "seconds",
                  );
                  if (res?.data?.isOtpSent && timeStampDiff <= 10) {
                    setIsMasterVendorOtpBox(true);
                    setMasterVendorEmail(res?.data?.masterVendorEmail);
                  } else if (res?.data?.success) {
                    setIsRegisteredSuccessful(true);
                    setTimeout(() => {
                      navigate("/auth/sign-in");
                    }, 700);
                  } else {
                    setIsRegisteredSuccessful(false);
                    setVerifyOtpError(res?.response?.data?.error?.type);
                  }
                })
                .catch((error) => {
                  setOTPVerified(false);
                  setVerifyOtpError(error?.response?.data?.error?.type);
                  setTimeout(() => {
                    setVerifyOtpError("");
                    setActiveStep(1);
                  }, 3000);
                  console.error(error);
                });
            });
          } else if (response?.data?.is_invalid) {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.data?.message);
          } else {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.response?.data?.error?.type);
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(error?.response?.data?.error?.type);
        })
        .finally(() => setOtpLoader(false));
    });
  };
  //jhsdj
  const resendOTP = () => {
    setOtpLoader(true);
    sendOtp({
      body: {
        phoneNumber: countryCode + userData.mobileNumber,
        otpType: "mobile",
      },
      apiType: "resend",
    })
      .then(() => {
        saveDate(Date.now() + 120000);
        saveDateKey(dateKey + 1);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setOtpLoader(false));
  };

  return isRegisteredSuccessful ? (
    <SuccessfullBanner />
  ) : (
    <div className="flex flex-col items-center justify-between pb-14 sm:pb-0">
       <ToastContainer position="top-center" />
      <div className="flex items-center justify-start w-full pt-8 divide-x-2 divide-black pl-11">
        <img src="/images/svg/moneyhop-logo.svg" alt="moneyhop-logo" className="mr-4" />
        <div className="flex-col items-start hidden pl-3 md:flex">
          <div className="text-base font-normal text-black font-ssp">
            Cross-border payments made
          </div>
          <div className="text-[22px] font-semibold text-black font-ssp">
            Smarter, Faster, Better.
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center w-screen mb-5 sm:mb-36 sm:w-max">
        <div className="flex text-xl font-bold text-primary font-ssp py-[42px]">Sign up</div>
        <div className="items-center justify-between hidden md:flex w-[497px]">
          <div className="flex flex-col items-center">
            <div
              className={clsx(
                isActiveStep === 1 ? "text-black" : "text-grey-550",
                "font-ssp text-lg font-bold",
              )}
            >
              Step 1
            </div>
            <div
              className={clsx(
                isActiveStep === 1 ? "text-black" : "text-grey-550",
                "font-normal text-base font-ssp pt-3",
              )}
            >
              Basic details
            </div>
          </div>
          <div>
            <RightArrowFilledIcon />
          </div>
          <div className="flex flex-col items-center">
            <div
              className={clsx(
                isActiveStep === 2 ? "text-black" : "text-grey-550",
                "font-ssp text-lg font-bold",
              )}
            >
              Step 2
            </div>
            <div
              className={clsx(
                isActiveStep === 2 ? "text-black" : "text-grey-550",
                "font-normal text-base font-ssp pt-3",
              )}
            >
              Mobile & email verification
            </div>
          </div>
        </div>
        {isActiveStep === 1 && (
          <StepOne
            setActiveStep={setActiveStep}
            saveUserData={saveUserData}
            countryCode={countryCode}
            userData={userData}
            saveCountryCode={saveCountryCode}
            setIsTermsModalOpen={setIsTermsModalOpen}
          />
        )}
        {isActiveStep === 2 && (
          <OtpPhase
            otpValue={otpValue}
            setOtpValue={saveOtpValue}
            otpError={otpError}
            verifyOTP={verifyOTP}
            otpLoader={otpLoader}
            isOTPVerified={isOTPVerified}
            verifyOtpError={verifyOtpError}
            resendOTP={resendOTP}
            dateKey={dateKey}
            isLoading={otpLoader}
            date={date}
            buttonText="Verify"
            rootClass="sm:mt-[70px] mt-11 z-10 mb-[7.25rem]"
          />
        )}
        <div
          className="z-10 mt-[10px] text-base font-bold text-center cursor-pointer text-primary"
          onClick={() => navigate("/auth/sign-in")}
        >
          Go back to login
        </div>
      </div>
      {isTermsModalOpen && (
        <TermsModal isTermsModalOpen={isTermsModalOpen} setIsTermsModalOpen={setIsTermsModalOpen} />
      )}
      {isMasterVendorOtpBox && (
        <MasterVendorOtpBoxModal
          isMasterVendorOtpBox={isMasterVendorOtpBox}
          setIsMasterVendorOtpBox={setIsMasterVendorOtpBox}
          masterVendorEmail={masterVendorEmail}
          userData={userData}
          setIsRegisteredSuccessful={setIsRegisteredSuccessful}
        />
      )}
      <Footer />
    </div>
  );
};

export default SignUp;